import '@axmit/garwin-api';
import { IRequestSuccess } from 'common/models';

export interface IBasketListParams extends Paths.BasketControllerList.QueryParameters {}
export interface IBasketCollection extends Components.Schemas.BasketCollectionDto {}
export interface IBasketItem extends Components.Schemas.BasketItemDto {}

export interface IBasket extends Components.Schemas.BasketDto {}
export interface IUpdateBasketPayload extends Components.Schemas.UpdateBasketDto, IRequestSuccess {}
export interface ICreateBasketRequestPayload extends Components.Schemas.CreateBasketRequestDto, IRequestSuccess {}

export interface ICreateBasketGood extends Components.Schemas.CreateBasketGoodDto {}
export interface IBasketGoods extends Components.Schemas.BasketGoodDto {}
export interface IDeleteBasketGoodPayload extends IRequestSuccess {
  id: number | null;
}

export interface IBasketListSubdivisionsParams extends Paths.BasketControllerGetSubdivisions.QueryParameters {}

export interface IBasketStoresPayload extends Components.Schemas.BasketStoreParamsDto {}
export interface IBasketStoreCollection extends Components.Schemas.BasketStoreCollectionDto {}

export interface IBasketStore extends Components.Schemas.BasketStoreDto {}

export interface IBasketDeliveryPayload extends Components.Schemas.BasketDeliveryParamsDto {}
export interface IBasketDelivery extends Components.Schemas.BasketDeliveryDto {}

export enum EDeliveryType {
  PickUp = 'pick_up',
  Delivery = 'delivery',
}

export enum EDeliveryTypeLabel {
  'pick_up' = 'Самовывоз',
  'delivery' = 'Доставка курьером',
}

export enum EPickUpDate {
  Today = 'today',
  Tomorrow = 'tomorrow',
  ManagerWillConfirm = 'manager_will_confirm',
}
